<template>
  <div class="account-profit">
    <!-- top -->
    <div class="account-profit-top" v-if="
      (isAgentLogin != AGENT_LOGIN_ROLE_VAL.AGENT || !disabled) &&
      isAgentLogin != AGENT_LOGIN_ROLE_VAL.AGENT_ADMIN
    ">
      <dashboard-card :balanceData="balanceData" @onWithdraw="onWithdraw" />
    </div>

    <el-tabs v-model="activeName" type="card" @tab-click="handleClick" class="account-profit-tabs">
      <el-tab-pane label="分润订单" name="first">
        <profit-sharing-order v-if="activeName === 'first'" ref="profitSharingOrder" :agentUserId="agentUserId"
          :disabled="disabled" />
      </el-tab-pane>
      <el-tab-pane label="提现记录" name="second" v-if="isAgentLogin != 2">
        <withdrawal-records v-if="activeName === 'second'" ref="withdrawalRecords" :agentUserId="agentUserId"
          :disabled="disabled" />
      </el-tab-pane>
      <el-tab-pane label="数字积分分润明细" name="third">
        <profit-table v-if="activeName === 'third'" ref="profitTable" :agentUserId="agentUserId" :disabled="disabled" />
      </el-tab-pane>
      <!-- <el-tab-pane label="TBC提现记录" name="fourth">
        <tbc-records
          v-if="activeName === 'fourth'"
          ref="tbcRecords"
          :agentUserId="agentUserId"
          :disabled="disabled"
        />
      </el-tab-pane> -->
    </el-tabs>
    <withdraw-dialog :dialog-visible="dialogFormVisible" :balance="balance" @save="handleSave"
      @close="handleDialogClose" :disabled="disabled" />
    <drawDialog :dialog-visible="dialogTbcVisible" :balance="cardData.tbc" @save="handleTbcSave"
      @close="handleTbcDialogClose" />
  </div>
</template>

<script>
import drawDialog from "@/views/dashboard/drawDialog.vue";
import profitTable from "./profit-table.vue";
import tbcRecords from "./tbc-records.vue";

import dashboardCard from "@/components/dashboardCard/index.vue";
import profitSharingOrder from "./profit-sharing-order.vue";
import withdrawalRecords from "./withdrawal-records.vue";
import { getLogionUserInfo } from "@/utils/auth";
import { AGENT_LOGIN_ROLE_VAL } from "@/utils/enumUtile";
import { getBalanceStatis, getTbcWithdraw } from "@/api/dashboard";
import withdrawDialog from "@/views/account-profit/components/withdraw-dialog.vue";

export default {
  props: {
    agentDetail: {
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeName: "first",
      balanceData: [],
      dialogFormVisible: false,
      dialogTbcVisible: false,
      balance: 0,
      isAgentLogin: null,
      agentUserId: "",
      cardData: {}
    };
  },
  created() {
    this.getTbcWithdrawData();
    this.isAgentLogin = getLogionUserInfo().isAgentLogin;
    this.agentUserId =
      (this.isAgentLogin == AGENT_LOGIN_ROLE_VAL.AGENT && this.disabled) ||
        this.isAgentLogin == AGENT_LOGIN_ROLE_VAL.AGENT_ADMIN
        ? this.agentDetail?.agentUserId
        : getLogionUserInfo().agentUserId;
  },
  mounted() { },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    onWithdraw(item) {
      console.log("item", item);
      if (item.name === "TBC余额") {
        this.dialogTbcVisible = true;
      } else {
        this.dialogFormVisible = true;
      }
    },
    // 查询btc账户
    getTbcWithdrawData() {
      getTbcWithdraw({}).then(resp => {
        if (resp && resp.bizcode === 100) {
          this.cardData = resp.data;
          this.onBalanceStatis();
        }
      });
    },
    onBalanceStatis() {
      console.log("1---1", this.agentUserId);
      getBalanceStatis({ agentUserId: this.agentUserId }).then(
        ({ data, bizcode }) => {
          if (bizcode === 100) {
            this.balanceData = [
              {
                name: "销售额",
                iconUrl: require("@/assets/dashboard/icon_cjcs.png"),
                todayAmount: data.todaySuccessAmount,
                cumulativeAmount: data.totalSuccessAmount,
                color: "#F1F7FF",
                leftTitle: "今日",
                rightTitle: "累计"
              },
              {
                name: "分润",
                iconUrl: require("@/assets/dashboard/icon_xjhb.png"),
                todayAmount: data.todayProfit,
                cumulativeAmount: data.totalProfit,
                color: "#FFF5EA",
                leftTitle: "今日",
                rightTitle: "累计"
              },
              {
                name: "账户余额",
                iconUrl: require("@/assets/dashboard/icon_xjyj.png"),
                todayAmount: data.balance,
                cumulativeAmount: data.totalBalance,
                color: "#FAF3FF",
                leftTitle: "今日",
                rightTitle: "累计",
                btn: "提现"
              },
              {
                name: "数字积分余额",
                iconUrl: require("@/assets/dashboard/icon_xjyj.png"),
                todayAmount: this.cardData.tbc,
                cumulativeAmount: this.cardData.lockTbc,
                color: "#FAF3FF",
                leftTitle: "可用余额",
                rightTitle: "锁仓余额"
                // btn: "提现"
              }, {
                name: "直推业绩",
                iconUrl: require("@/assets/dashboard/icon_xjyj.png"),
                cumulativeAmount: this.cardData.performance,
                color: "#FAF3FF",
                rightTitle: "业绩金额"
                // btn: "提现"
              },
            ];
            if (this.isAgentLogin == 2) {
              this.balanceData = this.balanceData.filter(
                item => item.name !== "分润" && item.name !== "账户余额"
              );
            }
            this.balance = data.balance;
          }
        }
      );
    },
    handleSave() {
      this.dialogFormVisible = false;
      this.$refs.profitSharingOrder.getList();
      this.$refs.withdrawalRecords.getList();
      this.onBalanceStatis();
    },
    handleTbcSave() {
      this.dialogTbcVisible = false;
    },
    handleTbcDialogClose() {
      this.dialogTbcVisible = false;
    },
    handleDialogClose() {
      this.dialogFormVisible = false;
    }
  },
  components: {
    profitSharingOrder,
    withdrawalRecords,
    dashboardCard,
    withdrawDialog,
    drawDialog,
    profitTable,
    tbcRecords
  },
  computed: {
    AGENT_LOGIN_ROLE_VAL() {
      return AGENT_LOGIN_ROLE_VAL;
    }
  }
};
</script>

<style lang="scss" scoped>
.account-profit {
  .account-profit-top {
    padding: 0 40px;
    margin-top: 20px;
  }

  @media screen and (max-width: 768px) {
    .account-profit-top {
      padding: 0;
      margin-top: 20px;
    }
  }

  ::v-deep .el-tabs {
    margin-top: 10px;
    padding: 10px 12px;
  }
}
</style>
